/* global SideDrawer */

/* Owner reported filters "always showing at the top of products" on
   mobile collection pages, instead of a "Filter & Sort" button that
   slides them out - confirmed this was a real, unfinished integration
   gap: the Meilisearch branch reused stock's <products-toolbar>
   component (products-toolbar.js), whose mobile click handler calls
   document.querySelector('facet-filters').open() - but a
   <facet-filters> element only ever gets rendered in the STOCK
   (non-Meilisearch) branch, so that call always failed silently here,
   and the filters div had no hide/show mechanism of its own at all.

   This defines a real <facet-filters> element for the Meilisearch
   branch (see main-collection-products.liquid) - safe to reuse that
   exact tag name since the real facet-filters.js (a much heavier class
   tied to stock's own filter-form/price-range markup, none of which
   applies to Meilisearch's own JS-driven filters) is never loaded
   alongside this file. Extends the same SideDrawer base every other
   drawer on the site already uses (cart, stock facet-filters) instead
   of reimplementing open/close/focus-trap/overlay logic, and reuses
   facet-filters.css completely unchanged - its own .facets.drawer media
   query already does exactly this component's whole job: position:
   fixed slide-in modal below the breakpoint, plain static sidebar
   column above it. */
if (!customElements.get('facet-filters')) {
  class LlmMeiliFilterDrawer extends SideDrawer {
    connectedCallback() {
      this.handleBreakpointChange();
      this.breakpointChangeHandler = this.breakpointChangeHandler
        || this.handleBreakpointChange.bind(this);
      window.addEventListener('on:breakpoint-change', this.breakpointChangeHandler);
    }

    disconnectedCallback() {
      window.removeEventListener('on:breakpoint-change', this.breakpointChangeHandler);
    }

    /**
     * Same pattern as stock's FacetFilters (facet-filters.js) - always
     * open/static on desktop (a plain sidebar column, not a modal),
     * closed by default on mobile until the "Filter & Sort" button
     * opens it.
     */
    handleBreakpointChange() {
      if (theme.mediaMatches.lg) {
        this.setAttribute('open', '');
        this.setAttribute('aria-hidden', 'false');
        this.removeAttribute('aria-modal');
        this.removeAttribute('role');
      } else {
        this.close();
        this.setAttribute('role', 'dialog');
        this.setAttribute('aria-modal', 'true');
        this.setAttribute('aria-hidden', 'true');
      }
    }
  }

  customElements.define('facet-filters', LlmMeiliFilterDrawer);
}
